// extracted by mini-css-extract-plugin
export default {"find-password":"Login_find-password__C2UVR","buttons":"Login_buttons__hkpur"};